// import "./vendors/pretty-dropdowns-4.17.0/dist/css/prettydropdowns.css?A";
import "./vendors/pretty-dropdowns-4.17.0/dist/js/jquery.prettydropdowns.js";

(function($) {
  $(document).ready(function() {
    $(".dropdown__select").prettyDropdown();
  });
})(jQuery);